import LinkNotificationList from '../LinksList';
import * as StyledComponents from '../../UnifyAdministration/Notification/StyledComponents';
import { AdminDataSideSheet } from '../../UnifyAdministration/Blocks/AdminDataSideSheet';
import { AdminDataSideSheetHeader } from '../../UnifyAdministration/Blocks/AdminDataSideSheetHeader';
import { LinkSideSheetBody } from '../LinksSideSheetBody';
import { useUnifyAdminStore } from '../../UnifyAdministration/AdminStore';
import {
  Toast,
  TOAST_POSITIONS,
  TOAST_VISIBILITY_DURATIONS,
  BUTTON_VARIANTS,
  BUTTON_ICON_COLORS,
  IconCancelOutlined,
} from 'cdk-radial';
import { useTranslation } from 'react-i18next';


export default function AppLinkAdminContainer(): JSX.Element {
  const { t } = useTranslation();
  const showToast = useUnifyAdminStore((state) => state.linkShowToast);
  const resetToastState = useUnifyAdminStore(
    (state) => state.resetLinkToastState
  );

  const toastMsg = useUnifyAdminStore((state) => state.linkToastMsg);
  const toastType = useUnifyAdminStore((state) => state.linkToastType);

  const setIsValidationState = useUnifyAdminStore(
    (state) => state.setIsLinkValidationState
  );

  const setWorkflowSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setAdminSideSheetCollapse
  );

  const isLinkSideSheetCollapse = useUnifyAdminStore(
    (state) => state.isLinkSideSheetCollapse
  );

  const setApplicationSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setWorkflowSideSheetCollapse
  );

  const setLinkSideSheetCollapse = useUnifyAdminStore(
    (state) => state.setLinkSideSheetCollapse
  );

  const resetLinkSideSheetState = useUnifyAdminStore(
    (state) => state.resetLinkSideSheetState
  );

  const handleCloseSideSheet = () => {
    setWorkflowSideSheetCollapse(true);
    setApplicationSideSheetCollapse(true);
    setLinkSideSheetCollapse(true);
    resetLinkSideSheetState();
  };

  return (
    <StyledComponents.StyledCustomScrollbarWrapperLink>
      <StyledComponents.StyledContainerWrapper data-testid="link-notification-container">
        {showToast && (
          <Toast
            id="link-notification-toast"
            datatestid="link-notification-toast"
            position={TOAST_POSITIONS.FIXED}
            style={{
              marginTop: '70px',
              zIndex: 1003,
            }}
            variant={toastType === 'Error' ? 'negative' : 'positive'}
            visibilityDuration={TOAST_VISIBILITY_DURATIONS.SIX_SECONDS}
            onVisibilityDurationEnd={() => {
              resetToastState();
              setIsValidationState(false);
            }}
            actions={[
              {
                onClick: () => {
                  resetToastState();
                  setIsValidationState(false);
                },
                variant: BUTTON_VARIANTS.ICON,
                icon: <IconCancelOutlined />,
                iconColor: BUTTON_ICON_COLORS.GRAY,
                text: '',
              },
            ]}
            content={toastMsg}
          />
        )}

        {!isLinkSideSheetCollapse && (
          <AdminDataSideSheet isCollapse={isLinkSideSheetCollapse} sidesheetName={'Link'}>
            <AdminDataSideSheetHeader
              sideSheetHeaderTitle={t('linksAdmin.sideSheetTitle')}
              handleSideSheetClose={handleCloseSideSheet}
            />
            <div style={{display:'flex'}}>
            <LinkSideSheetBody />
            </div>
          </AdminDataSideSheet>
        )}
        <LinkNotificationList></LinkNotificationList>
      </StyledComponents.StyledContainerWrapper>
    </StyledComponents.StyledCustomScrollbarWrapperLink>
  );
}